import React from "react";
import { X } from "lucide-react";
import { S } from "../theme/sharedStyles";
import { LINK_CATS } from "../constants/misc";
import { uid } from "../utils/storage";
import { CategoryIcon } from "./CategoryIcon";

export const LinkEditor = ({ links = [], onChange }) => {
  const [adding, setAdding] = React.useState(false);
  const [cat, setCat] = React.useState("");
  const [url, setUrl] = React.useState("");
  const [customLabel, setCustomLabel] = React.useState("");

  const catMeta = LINK_CATS.find(c => c.key === cat);

  const commitLink = () => {
    if (!cat || !url.trim()) return;
    const newLink = { id: uid(), cat, url: url.trim(), label: customLabel.trim() };
    onChange([...links, newLink]);
    setCat(""); setUrl(""); setCustomLabel(""); setAdding(false);
  };

  const removeLink = (id) => onChange(links.filter(l => l.id !== id));

  return (
    <div style={{ marginTop: 12 }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 6 }}>
        <p style={{ ...S.label, margin: 0 }}>LINKS</p>
        {!adding && (
          <button onClick={() => setAdding(true)}
            style={{ fontSize: 11, color: "var(--c-text-accent)", background: "var(--c-bg-card)", border: "1.5px solid #f0c0d8", borderRadius: 10, padding: "3px 10px", cursor: "pointer", fontFamily: "inherit", fontWeight: 700 }}>
            + Add Link
          </button>
        )}
      </div>

      {/* Saved links as chips */}
      {links.length > 0 && (
        <div style={{ display: "flex", flexWrap: "wrap", gap: 5, marginBottom: adding ? 10 : 0 }}>
          {links.map(l => {
            const meta = LINK_CATS.find(c => c.key === l.cat);
            const display = l.label || meta?.label || l.cat;
            return (
              <div key={l.id} style={{ display: "flex", alignItems: "center", gap: 4, background: "var(--c-bg-soft)", border: "1.5px solid #f0c8e0", borderRadius: 20, padding: "3px 8px 3px 10px", fontSize: 11, color: "var(--c-text-mid)" }}>
                <a href={l.url} target="_blank" rel="noopener noreferrer"
                  style={{ textDecoration: "none", color: "inherit", fontWeight: 600, display: "flex", alignItems: "center", gap: 4 }}>
                  <span>{meta?.emoji || "🔗"}</span>
                  <span>{display}</span>
                </a>
                <button onClick={() => removeLink(l.id)}
                  style={{ background: "transparent", border: "none", cursor: "pointer", color: "#c09090", fontSize: 12, padding: "0 0 0 2px", lineHeight: 1 }}><X size={16} /></button>
              </div>
            );
          })}
        </div>
      )}

      {/* Add link form */}
      {adding && (
        <div style={{ background: "var(--c-bg-card)", border: "1.5px solid #f0d0e8", borderRadius: 14, padding: "12px 12px 10px" }}>
          {/* Category picker */}
          <p style={{ ...S.label, marginBottom: 6 }}>LINK TYPE</p>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 5, marginBottom: 10 }}>
            {LINK_CATS.map(c => (
              <button key={c.key} onClick={() => { setCat(c.key); setUrl(""); }}
                style={{ display: "flex", alignItems: "center", gap: 5, padding: "5px 10px", borderRadius: 20,
                  border: cat === c.key ? "2px solid #d4789a" : "1.5px solid #f0d0e8",
                  background: cat === c.key ? "var(--c-bg-card)" : "transparent",
                  color: cat === c.key ? "#d4789a" : "#9a7090",
                  fontSize: 12, fontWeight: 700, cursor: "pointer", fontFamily: "inherit" }}>
                <CategoryIcon cat={c} size={14} /><span>{c.label}</span>
              </button>
            ))}
          </div>

          {/* URL input — shown after category picked */}
          {cat && (
            <>
              <p style={{ ...S.label, marginBottom: 10 }}>URL</p>
              <input
                value={url} onChange={e => setUrl(e.target.value)}
                placeholder={catMeta?.placeholder || "Paste link…"}
                style={{ ...S.input, marginBottom: 8 }}
                onKeyDown={e => e.key === "Enter" && commitLink()}
              />
              <p style={{ ...S.label, marginBottom: 10 }}>CUSTOM LABEL <span style={{ color: "var(--c-text-soft)", fontWeight: 400, textTransform: "none" }}>(optional)</span></p>
              <input
                value={customLabel} onChange={e => setCustomLabel(e.target.value)}
                placeholder={`e.g. "Team standup", "Client office"…`}
                style={{ ...S.input, marginBottom: 10 }}
                onKeyDown={e => e.key === "Enter" && commitLink()}
              />
            </>
          )}

          <div style={{ display: "flex", gap: 6 }}>
            <button onClick={commitLink} disabled={!cat || !url.trim()}
              className="clarity-add-btn"
              style={{ ...S.addBtn, opacity: (!cat || !url.trim()) ? 0.4 : 1, cursor: (!cat || !url.trim()) ? "not-allowed" : "pointer", flex: 1 }}>
              Save Link
            </button>
            <button onClick={() => { setAdding(false); setCat(""); setUrl(""); setCustomLabel(""); }}
              style={{ ...S.btn, flex: 1 }}><X size={14} style={{marginRight:4}} />Cancel</button>
          </div>
        </div>
      )}
    </div>
  );
};
